type objectWithFieldsAndValues = {
    [key: string]: string | number;
};

type searchAbleArrayOfObjects = objectWithFieldsAndValues[];

/**
 * Searches through array of objects,
 * and checks if there is any match for the given field with the given value
 *
 * @param {string} field
 * @param {string|number} value
 * @param {searchAbleArrayOfObjects} array
 * @returns {boolean}
 */
export const HasFieldValueInArrayOfObjects = (
    field: string,
    value: string | number,
    array: searchAbleArrayOfObjects,
): boolean => {
    if (!array.length) {
        return false;
    }
    let index = 0;
    while (index < array.length) {
        const obj = array[index];
        if (obj[field] === value) {
            return true;
        }
        index++;
    }
    return false;
};
